module.exports = __webpack_public_path__ + "img/gaxon.0571048e.svg";